/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Discount_RulesInputs */

const vi_discount_rules = /** @type {(inputs: Discount_RulesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Quy tắc chiết khấu`)
};

/**

* @param {Discount_RulesInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const discount_rules = /** @type {((inputs?: Discount_RulesInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Discount_RulesInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_discount_rules(inputs)
});